import lng from '@lightningjs/core';
import { Colors, Router, Storage, Utils } from '@lightningjs/sdk';

export default class SidebarItem extends lng.Component {
  static _template() {
    return {
      Item: {
        collision: true,
        h: 100,
        flex: { alignItems: 'center', justifyContent: 'center' },
        Image: {
          FocusRing: {},
        },
        Text: {
          text: {
            fontFace: 'OpenSans-SemiBold',
            text: '',
            textAlign: 'center',
            textOverflow: 'ellipsis',
            fontSize: 36,
            wordWrapWidth: 125,
            maxLines: 1,
            wordWrap: false,
          },
          y: 5,
        },
      },
    };
  }
  _construct() {
    super._construct();
  }
  set item({ id, image, height, path, title }) {
    this._item = { id, image, height, path, title };
  }

  get _Image() {
    return this.tag('Image');
  }

  get _Text() {
    return this.tag('Text');
  }

  get _FocusRing() {
    return this.tag('FocusRing');
  }

  set index(val) {
    this._index = val;
  }

  _focus() {
    super._focus();
    this.fireAncestors('$itemChanged');
    this._Text.patch({
      color: Colors('#02AC25').get(),
    });
    this._item.id != 1 &&
      this._Image.patch({
        color: Colors('#02AC25').get(),
      });
    this._item.id === 1 &&
      this._FocusRing.patch({
        texture: lng.Tools.getRoundRect(72, 72, 72 / 2, 3, Colors('#02AC25').get(), false),
      });
  }

  _enable() {
    this._Text.patch({
      color: Colors('#D6D6D7').get(),
    });
    this._Image.patch({
      color: Colors('#D6D6D7').get(),
    });

    this._item.id === 1 &&
      this._FocusRing.patch({
        texture: lng.Tools.getRoundRect(72, 72, 72 / 2, 3, Colors('#ffffff').get(), false),
      });
  }

  _unfocus() {
    super._unfocus();
    this._Text.patch({
      color: Colors('#D6D6D7').get(),
    });
    this._Image.patch({
      color: Colors('#D6D6D7').get(),
    });

    this._item.id === 1 &&
      this._FocusRing.patch({
        texture: lng.Tools.getRoundRect(72, 72, 72 / 2, 3, Colors('#ffffff').get(), false),
      });
  }

  _handleHover() {
    this.fireAncestors('$setIndex', this._index);

    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleClick() {
    this._handleEnter();
  }

  _handleEnter() {
    Router.navigate(this._item.path);
    Router.focusPage('MyListPage');
  }

  _active() {
    let profileInfo = Storage.get('profileInfo');
    if (this._item.id === 1) {
      this._Image.patch({
        texture: lng.Tools.getSvgTexture(profileInfo.image, 72, 72),
        shader: {
          type: lng.shaders.RoundedRectangle,
          radius: 72 / 2,
        },
      });
      this._Text.patch({
        x: 30,
        text: {
          text: profileInfo.name,
          fontSize: 30,
        },
      });
      this._FocusRing.patch({
        w: 72,
        h: 72,
        mount: 0.5,
        x: 72 / 2,
        y: 72 / 2,
        zIndex: 2,

        texture: lng.Tools.getRoundRect(72, 72, 72 / 2, 3, Colors('#d6d6d7').get(), false),
      });
    }
  }

  _firstEnable() {
    if (this._item.id !== 1) {
      this.patch({});
      this._Image.patch({
        x: 20,
        texture: lng.Tools.getSvgTexture(Utils.asset(this._item.image), 38, this._item.height),
      });
      this._Text.patch({
        x: 60,
        text: {
          text: this._item.title,
          fontSize: 30,
        },
      });
    } else {
      this._Text.patch({
        x: 40,
        text: {
          text: this._item.title,
          fontSize: 30,
        },
      });
      this._Image.patch({
        texture: lng.Tools.getSvgTexture(Storage.get('profile-img'), 72, 72),
        shader: {
          type: lng.shaders.RoundedRectangle,
          radius: 38 / 2,
        },
      });
      this._item.id == 1 &&
        this._FocusRing.patch({
          w: 72,
          h: 72,
          mount: 0.5,
          x: 72 / 2,
          y: 72 / 2,
          zIndex: 2,

          texture: lng.Tools.getRoundRect(72, 72, 72 / 2, 3, Colors('#D6D6D7').get(), false),
        });
    }
  }
}
